import Vue from 'vue'
import { Module, ActionContext } from 'vuex'
import {
  RootState,
  AffiliateManager,
  LocationCustomisation,
} from './state_models'
import to from 'await-to-js'
import AffiliateManagerService from '../services/AffiliateManagerService'

export const enum AffiliateOptions {
  AFFILIATES = 'Affiliates',
  CAMPAIGNS = 'Campaigns',
  PAYOUTS = 'Payouts',
  MEDIA = 'Media',
  TITLE = 'Affiliate Manager',
}

export const affiliateManager: Module<AffiliateManager, RootState> = {
  namespaced: true,
  state: {
    locationCustomisation: {
      affiliateName: AffiliateOptions.AFFILIATES,
      titleName: AffiliateOptions.TITLE,
      payoutName: AffiliateOptions.PAYOUTS,
      mediaName: AffiliateOptions.MEDIA,
      campaignName: AffiliateOptions.CAMPAIGNS,
      isLoaded: false,
    },
  },
  getters: {
    getLocationCustomisation: (state: AffiliateManager) => {
      return state.locationCustomisation
    },
  },
  mutations: {
    set: (
      state: AffiliateManager,
      payload: { locationCustomisation: LocationCustomisation }
    ) => {
      if (payload.locationCustomisation) {
        const {
          affiliateName,
          titleName,
          campaignName,
          payoutName,
          mediaName,
          isLoaded
        } = payload.locationCustomisation
        ;(state.locationCustomisation.affiliateName = affiliateName),
          (state.locationCustomisation.titleName = titleName),
          (state.locationCustomisation.payoutName = payoutName),
          (state.locationCustomisation.mediaName = mediaName),
          (state.locationCustomisation.campaignName = campaignName),
          (state.locationCustomisation.isLoaded = isLoaded)
      }
    },
  },
  actions: {
    async syncLocationCustomisation(
      context: ActionContext<AffiliateManager, RootState>,
      locationId: string
    ) {
      if (!locationId) {
        return
      }

      const [err, response] = await to(
        AffiliateManagerService.getLocationCustomisation(locationId)
      )
      if (err) {
        return
      }

      const payload: LocationCustomisation = {
        affiliateName:
          response?.altAffiliateName || AffiliateOptions.AFFILIATES,
        campaignName: response?.altCampaignName || AffiliateOptions.CAMPAIGNS,
        payoutName: response?.altPayoutName || AffiliateOptions.PAYOUTS,
        mediaName: response?.altMediaName || AffiliateOptions.MEDIA,
        titleName: response?.altTitleName || AffiliateOptions.TITLE,
        isLoaded: true,
      }
      context.commit('set', {
        locationCustomisation: payload,
      })
    },
  },
}
